export default __webpack_public_path__ + "8301e04f057caf08928ed2a3b85c5603.png";